/* eslint-disable */
import { request } from '@umijs/max';

export interface APIResult<T> {
  code: number;
  msg: string;
  data: T;
}

export interface RoleDetailResultItem {
  id: number;
  deptId: number;
  name: string;
  code: string;
  remark: string;
  enableStatus: number;
  systemRole: number;
  createTime: string;
  permissions: PermissionRoleItem[];
}

export interface PermissionRoleItem {
  permissionId: number;
  permissionCode: string;
  buttonId: any;
  buttonCode: string;
}

export interface PermissionResultItem {
  swimPermissionItem: {
    id: number;
    parentId: number;
    name: string;
    code: string;
    type: string;
    path: string;
    component: string;
    icon: string;
    sortOrder: number;
    isHidden: number;
    description?: string;
    status: number;
  };
  buttonList: ButtonResultItem[];
}

export interface ButtonResultItem {
  id: number;
  pageCode: number;
  permissionCode: string;
  buttonName: string;
  buttonCode: string;
  placement: string;
  buttonUiIcon: string;
}

// 获取全量部门数据
/** 获取全量部门数据 GET /web/v1/dept/list */
export async function getAllPermissionItemButtonList(options?: {
  [key: string]: any;
}) {
  return request<APIResult<PermissionResultItem[]>>(
    '/web/v1/permission/getAllPermissionItemButtonList',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 获取部门树形结构 GET /web/v1/dept/tree */
export async function getDeptTree(options?: { [key: string]: any }) {
  return request<API.YmResultVOListDeptTreeNode>('/web/v1/dept/tree', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 分页查询角色 POST /web/v1/role/pageList */
export async function getRolePageList(
  body: API.RolePageQueryVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOPageRoleInfo>('/web/v1/role/pageList', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 新增-更新角色 POST /web/v1/role/upsert */
export async function upsertRole(
  body: API.RoleUpsertVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/role/upsert', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 根据id删除角色 POST /web/v1/role/delete/${param0} */
export async function deleteRole(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteRoleParams,
  options?: { [key: string]: any },
) {
  const { roleId: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/role/delete/${param0}`, {
    method: 'POST',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 根据id启用角色 POST /web/v1/role/enable/${param0} */
export async function enableRole(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.enableRoleParams,
  options?: { [key: string]: any },
) {
  const { roleId: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/role/enable/${param0}`, {
    method: 'POST',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 根据id禁用角色 POST /web/v1/role/disable/${param0} */
export async function disableRole(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.disableRoleParams,
  options?: { [key: string]: any },
) {
  const { roleId: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/role/disable/${param0}`, {
    method: 'POST',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 获取权限列表 GET /web/v1/permission/permissionItemList */
export async function getPermissionList(options?: { [key: string]: any }) {
  return request<API.YmResultVOListPermissionItem>(
    '/web/v1/permission/permissionItemList',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

export interface GetRolePermissionsVo {
  id: number;
  gymId: number;
  scopeType: string;
  deptId: number;
  spaceId: number;
  name: string;
  code: string;
  remark: string;
  enableStatus: number;
  systemRole: number;
  createTime: string;
  createUser: number;
  updateTime: string;
  updateUser: number;
  permissions: PermissionRoleItem[];
}

/** 获取角色权限 GET /web/v1/role/permissions/${param0} */
export async function getRolePermissions(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: { roleId: number },
  options?: { [key: string]: any },
) {
  const { roleId, ...queryParams } = params;
  return request<APIResult<GetRolePermissionsVo>>(
    `/web/v1/role/roleDetail/${roleId}`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

export interface SetRolePermissionsVo {
  roleId: number;
  swimPermissionsToRoleAdds?: {
    permissionId?: number; // 模块或者菜单的id
    permissionCode?: string; // 模块或者菜单的编码
    buttonId?: any; // 按钮的id
    buttonCode?: string; // 按钮的编码
  }[];
}

/** 设置角色权限 POST */
export async function setRolePermissions(
  body: SetRolePermissionsVo[],
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/role/grantPermission', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

// 获取所有的菜单按钮 ，权限树
export async function getAllPermissionTree(options?: { [key: string]: any }) {
  return request<API.YmResultVOListPermissionTreeVo>(
    '/web/v1/permission/getAllPermissionTree',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

// 登陆的时候根据用户角色id获取菜单权限
export async function getMenuPermissions(
  roleId: any,
  options?: { [key: string]: any },
) {
  return request<APIResult<PermissionResultItem[]>>(
    `/web/v1/role/getRoleAllPermissionItemAndButtonList/${roleId}`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}
